import { logger } from "cayo.ui";
import { withTemporaryToken } from "@cayo/shared/utils/download";
import { IActionHandlerParams } from "../types";

const log = logger.getLogger("action-handlers");

const openUrlHelper = (url: string) => {
  log.debug("openUrl", url);
  window.open(url, "_blank");
};

const getEncodedValues = (objects: any[] | undefined, propName?: string) => {
  if (!objects || !propName) {
    return undefined;
  }

  return objects.map((o) => encodeURIComponent(o[propName])).join(";");
};

export const openUrl = (actionId: string, parameters?: IActionHandlerParams) => {
  let url = actionId;
  const actionParams = parameters?.actionParameters;

  if (!actionParams?.objectIdPropName) {
    openUrlHelper(actionId);
    return;
  }

  const selectedIds = getEncodedValues(parameters?.objects, actionParams.objectIdPropName);
  if (selectedIds) {
    url = url.replace("{SelectedIds}", selectedIds);
  }

  const selectedSids = getEncodedValues(parameters?.objects, actionParams.objectSidPropName);
  if (selectedSids) {
    url = url.replace("{SelectedSids}", selectedSids);
  }

  withTemporaryToken(() => openUrlHelper(url));
};
